import { UserAbility } from "modules/user/config/permissions/Can";

export const ability: Partial<UserAbility> = {
  research: {
    read: ["all"],
    create: ["master", "program_manager", "administrator", "staff", "client"],
    update: ["master", "program_manager", "administrator", "staff", "client"],
    delete: ["master", "program_manager", "administrator", "staff", "client"],
    config: ["master", "program_manager"]
  },
  observation: {
    read: ["all"],
    create: ["master", "program_manager", "administrator", "staff", "client"],
    update: ["master", "program_manager", "administrator", "staff", "client"],
    delete: ["master", "program_manager", "administrator", "staff", "client"],
    config: ["master", "program_manager"]
  }
};
